import { api, headersConfig } from "../../services/api";

const service_path = '/orders.php';

export async function getOrders(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value != null) {
            params.set(key, String(value));
        }
    });
    const query = params.toString();
    const response = await api.get(query ? `${service_path}?${query}` : service_path, headersConfig);

    return response;
};

export async function getOrderDetails(id) {

    const response = await api.get(`${service_path}?id=` + id, headersConfig);

    return response;
};

export async function createOrder(payload) {

    const response = await api.post(service_path, payload, headersConfig);

    return response;
};


